import React, { useCallback } from 'react';
import { Prompt } from '../../../components/Prompt/Prompt.component';
import { enableExaminersInexaminersTreemap } from '../../../services/exams/assessmentSession/assessments.service';
import { useLayoutContext } from '../../../Context/Layout.context';
import { BlockadeTypeId } from '../../../components/ExaminersStructure/ExaminersStructure.types';

export const EnableExaminers: React.FC<{
  onSuccess: () => void;
  onFailure: () => void;
  blockadeFilterType: BlockadeTypeId;
  allToUnblock: boolean;
  isSearch?: boolean;
}> = (props) => {
  const { showLoader, openAlert } = useLayoutContext();

  const getBlockadeFilterParams = () => {
    switch (props.blockadeFilterType) {
      case BlockadeTypeId.None:
        return undefined;
      case BlockadeTypeId.Automatic:
        return ['1'];
      case BlockadeTypeId.Manual:
        return ['2'];
      case BlockadeTypeId.Any:
        return ['1', '2'];
    }
  };

  const enableExaminersBySupervisorPermissionId = useCallback(() => {
    showLoader(true);
      enableExaminersInexaminersTreemap(getBlockadeFilterParams())
        .then(
          () => {
            openAlert('success');
            props.onSuccess();
          },
          () => {
            openAlert('error');
            props.onFailure();
          },
        )
        .finally(() => {
          showLoader(false);
        });
  }, [getBlockadeFilterParams]);

  return (
    <Prompt
      type="confirmation"
      isBold={true}
      open={true}
      mainText={
        (props.blockadeFilterType === BlockadeTypeId.None && !props.isSearch) || props.allToUnblock
          ? 'Czy na pewno chcesz odblokować wszystkich egzaminatorów?'
          : 'Czy na pewno chcesz odblokować wyszukanych egzaminatorów?'
      }
      subTexts={[
        {
          text: 'Odblokowanie egzaminatorów wznowi możliwość pobierania prac.',
        },
      ]}
      onConfirm={enableExaminersBySupervisorPermissionId}
      onCancel={props.onFailure}
      mainActionButtonText="TAK"
    />
  );
};
